<template>
  <div class="m-2">
    <div class="p-5 border-solid border-2 rounded-lg">
      <h6 class="text-center">{{ title }}</h6>
      <div class="mb-2">
        <label>Ingredient</label>
        <select-2
          autocomplete
          class="w-full"
          ref="ingredient"
          :value="ingredient.ingredientId"
          @input="
            (item) =>
              item &&
              $emit('update:ingredient', {
                ...ingredient,
                ingredientId: item && item.value,
                weightType: item && item.inventories_weight_type
              }) &&
              $nextTick(() => $emit('inventory-changed'))
          "
          name="Ingredient"
          placeholder="Select Ingredient"
          :options="ingredientOptions"
        />
      </div>
      <div class="mb-2">
        <label>Ingredient Weight Type</label>
        <select-2
          autocomplete
          class="w-full"
          :value="ingredient.weightType"
          @input="
            (item) =>
              this.$emit('update:ingredient', {
                ...this.ingredient,
                weightType: item && item.value
              })
          "
          name="Weight Type"
          placeholder="Select Weight Type"
          :options="weightTypes"
          v-validate="'required_if_not_null:ingredient'"
        />
        <span class="text-danger text-sm" v-show="errors.has('Weight Type')">{{ errors.first('Weight Type') }}</span>
      </div>
      <div class="mb-1">
        <vs-input disabled class="w-full" label="Available Quantity" name="Available Quantity" ref="avail_qty" :value="ingredientAvailQuantity" />
      </div>
      <div class="mb-1">
        <vs-input
          class="w-full mb-1"
          type="number"
          v-model="ingredient.ingredient_quantity"
          @change="
            (event) =>
              $emit('update:ingredient', {
                ...ingredient,
                ingredient_quantity: mathRound(event.target.value, 3)
              })
          "
          step="0.001"
          label="Ingredient Quantity"
          name="Ingredient Quantity"
          v-validate="`required_if_not_null:ingredient|not_zero:ingredient|less_then_and_equal:avail_qty,${ingredient.ingredientId || 0}`"
        />
        <span class="text-danger text-sm" v-show="errors.has('Ingredient Quantity')">{{ errors.first('Ingredient Quantity') }}</span>
      </div>
      <div class="vx-col w-full">
        <div class="mt-8 flex justify-center mr-5">
          <vx-tooltip text="Add Inventoty">
            <vs-button class="mr-2" type="filled" color="primary" icon-pack="feather" icon="icon-plus" @click="$emit('add-ingredient')" />
            <!-- <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="$emit('add-ingredient')" /> -->
          </vx-tooltip>
          <vx-tooltip text="Remove Inventoty">
            <vs-button class="mr-2" type="filled" color="danger" icon-pack="feather" icon="icon-trash-2" @click="$emit('remove-ingredient', ingredient.id)" />
            <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="$emit('remove-ingredient', ingredient.id)" /> -->
          </vx-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import DynamicSelect from '@/components/custom/form-elements/DynamicSelect.vue'
import { weightTypes, weightMixins } from '@/utils/weightType'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'Ingredient',
  components: {
    DynamicSelect,
    Select2
  },
  props: {
    title: {},
    ingredient: {}
  },
  data() {
    return {
      weightTypes
    }
  },
  mixins: [weightMixins],
  computed: {
    ...mapGetters('inventory', ['ingredientOptions']),
    validateForm() {
      return !this.errors.any()
    },
    ingredientAvailQuantity() {
      if (this.ingredient.ingredientId && this.ingredient.weightType && this.$refs['ingredient']) {
        const ingredient = this.$refs['ingredient'].vOptions.find((op) => op.value === this.ingredient.ingredientId)
        if (ingredient) {
          const weight = this.convertAvailableQty(ingredient.inventories_quantity, ingredient.inventories_weight_type)[this.ingredient.weightType]
          return weight
        }
      }
      return 0
    }
  },
  watch: {
    'ingredient.weightType'() {
      this.$emit('update:ingredient', {
        ...this.ingredient,
        ingredient_quantity: this.ingredientAvailQuantity >= this.ingredient.ingredient_quantity ? this.ingredient.ingredient_quantity : 0
      })
    }
  },
  created() {
    this.$validator.extend(
      'required_if_not_null',
      {
        validate: (value, [otherValue]) => {
          if (otherValue) {
            return !!value
          }
          return true
        },
        getMessage: (name) => {
          return `field ${name} is required`
        }
      },
      {
        hasTarget: true
      }
    )
    this.$validator.extend(
      'not_zero',
      {
        validate: (value, [check]) => {
          return check ? value > 0 : true
        },
        getMessage: (field) => `field ${field} can't zero or less`
      },
      {
        hasTarget: true
      }
    )
    this.$validator.extend(
      'less_then_and_equal',
      {
        validate: (value, [availQty, check]) => {
          if (parseInt(check)) {
            return availQty >= value
          }
          return true
        },
        getMessage: (name) => {
          return `field ${name} can't be more-then avalialble quantity`
        }
      },
      {
        hasTarget: true
      }
    )
  }
}
</script>
